import { observer } from 'mobx-react'
import { layoutStore, mainStore } from 'enasops/stores'

const Title = () => {
  const { NAME } = mainStore.activeMenu
  return (
    <div className='content__title'>
      <span className='content__title-left'>{NAME}</span>
      {layoutStore.titleSlot}
    </div>
  )
}

export default observer(Title)